<template>
  <div>
    <v-alert
      v-for="n in filteredNewsItems"
      :ref="`news-${n.id}`"
      :key="n.id"
      :type="$filters.getUrgentNewsColor(n.type)"
      mode="out-in"
      dismissible
    >
    <div class="flatp" v-html="$filters.getMatchingTranslation({ value: n.text, locale: $i18n.locale })"></div>
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import newsListeners from '@/listeners/news'

export default {
  name: 'NewsPanel',
  computed: {
    ...mapGetters({
      news: ['news/getNews']
    }),
    filteredNewsItems () {
      const now = new Date()
      return this.news.filter(item => {
        const newsDate = new Date(item.showuntil)
        return newsDate.getTime() >= now.getTime()
      })
    },
    lang () {
      return this.$store.getters['app/projectLanguage']
    }
  },
  methods: {
    async getNews () {
      try {
        await this.$store.dispatch('news/setNews')
      } catch (error) {
        const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
        this.$oops(errorMessage)
      }
    }
  },
  created () {
    this.getNews()
    if (this.leave === true) {
      setTimeout(() => {
        this.newsAlertOn = false
      }, 5000)
    }

    // Subscribe to events
    this.sockets.subscribe('POST/newsItem', newsListeners.postNewsItem.bind(this))

    this.sockets.subscribe('PUT/newsItem', newsListeners.postNewsItem.bind(this))
  },
  beforeDestroy () {
    this.sockets.unsubscribe('POST/newsItem')
    this.sockets.unsubscribe('PUT/newsItem')
  }
}
</script>

<style lang="scss" scoped>
  .flatp ::v-deep > p:last-child {
    margin-bottom: 0;
  }
</style>
